import { render, staticRenderFns } from "./BehaviorsFilters.vue?vue&type=template&id=1bc91f94"
import script from "./BehaviorsFilters.vue?vue&type=script&lang=js"
export * from "./BehaviorsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports